import React, { Suspense, forwardRef } from "react";
import LoadingFallback from "./LoadingFallback";

const lazyLoad = (importFunc) => {
  const LazyComponent = React.lazy(importFunc);
  const Wrapped = forwardRef((props, ref) => (
    <Suspense fallback={<LoadingFallback />}>
      <LazyComponent ref={ref} {...props} />
    </Suspense>
  ));
  Wrapped.displayName = "LazyMaterialComponent";
  return Wrapped;
};
export const Paper = lazyLoad(() => import("@mui/material/Paper"));
export const AppBar = lazyLoad(() => import("@mui/material/AppBar"));
export const Toolbar = lazyLoad(() => import("@mui/material/Toolbar"));
export const Typography = lazyLoad(() => import("@mui/material/Typography"));
export const IconButton = lazyLoad(() => import("@mui/material/IconButton"));
export const Avatar = lazyLoad(() => import("@mui/material/Avatar"));
export const TextField = lazyLoad(() => import("@mui/material/TextField"));
export const Button = lazyLoad(() => import("@mui/material/Button"));
export const Box = lazyLoad(() => import("@mui/material/Box"));
export const Tab = lazyLoad(() => import("@mui/material/Tab"));
export const Tabs = lazyLoad(() => import("@mui/material/Tabs"));
export const CircularProgress = lazyLoad(() => import("@mui/material/CircularProgress"));
export const InputAdornment = lazyLoad(() => import("@mui/material/InputAdornment"));
export const Grid = lazyLoad(() => import("@mui/material/Grid"));
export const CloseIcon = lazyLoad(() => import("@mui/icons-material/Close"));
export const ColorLensIcon = lazyLoad(() => import("@mui/icons-material/ColorLens"));
/*
export const PersonIcon = lazyLoad(() => import("@mui/icons-material/Person"));
*/
export const AddCircleOutlineIcon = lazyLoad(() => import("@mui/icons-material/AddCircleOutline"));
export const FullscreenIcon = lazyLoad(() => import("@mui/icons-material/Fullscreen"));
export const FullscreenExitIcon = lazyLoad(() => import("@mui/icons-material/FullscreenExit"));
export const ThumbUpAltOutlinedIcon = lazyLoad(() => import("@mui/icons-material/ThumbUpAltOutlined"));
export const ThumbDownAltOutlinedIcon = lazyLoad(() => import("@mui/icons-material/ThumbDownAltOutlined"));
export const SendIcon = lazyLoad(() => import("@mui/icons-material/Send"));
export const OpenInNewIcon = lazyLoad(() => import("@mui/icons-material/OpenInNew"));
export const CloseFullscreenIcon  = lazyLoad(() => import("@mui/icons-material/CloseFullscreen"));
// Add more components as needed
export const Checkbox = lazyLoad(() => import("@mui/material/Checkbox"));
export const FormControlLabel = lazyLoad(() => import("@mui/material/FormControlLabel"));
export const FormGroup = lazyLoad(() => import("@mui/material/FormGroup"));
export const Switch = lazyLoad(() => import("@mui/material/Switch"));
export const Dialog = lazyLoad(() => import("@mui/material/Dialog"));
export const DialogActions = lazyLoad(() => import("@mui/material/DialogActions"));
export const DialogContent = lazyLoad(() => import("@mui/material/DialogContent"));
export const DialogContentText = lazyLoad(() => import("@mui/material/DialogContentText"));
export const DialogTitle = lazyLoad(() => import("@mui/material/DialogTitle"));
export const Tooltip = lazyLoad(() => import("@mui/material/Tooltip"));
export const InfoOutlinedIcon = lazyLoad(() => import("@mui/icons-material/InfoOutlined"));
export const Card = lazyLoad(() => import("@mui/material/Card"));
export const CardMedia = lazyLoad(() => import("@mui/material/CardMedia"));
export const Link = lazyLoad(() => import("@mui/material/Link"));

// React Draggable
export const Draggable = lazyLoad(() => import("react-draggable"));

//Typewriter-effect
export const Typewriter = lazyLoad(() => import("typewriter-effect"));
